import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=20b17768"
import script from "./Section.vue?vue&type=script&lang=ts"
export * from "./Section.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports